import { Icon, IconName } from '@usealloy/component-library';
import React from 'react';

import type { ExitNode as IExitNode, WorkflowNodeProps } from 'flow/service/graph';

import BaseNode from '../BaseNode';


function ExitNode(props: WorkflowNodeProps<IExitNode>) {
  const {
    id,
    type,
  } = props;

  return (
    <BaseNode
      icon={
        <Icon icon={IconName.OctagonXmark} size="large" />
      }
      id={id}
      label="Exit Workflow"
      stateStyle={{
        baseBackgroundColor: 'var(--cl-red-300)',
        highlighted: {
          backgroundColor: 'var(--cl-red-400)',
        },
        hovered: {
          backgroundColor: 'var(--cl-red-400)',
        },
      }}
      type={type}
    />
  );
}

export default React.memo(ExitNode);
